import CemeteryAdapter from '../Cemetery/adapter';
import ParishAdapter from '../Parish/adapter';
import SchoolAdapter from '../School/adapter';
export const adapterMap = {
  cemetery: CemeteryAdapter,
  parish: ParishAdapter,
  school: SchoolAdapter
};